module.exports = __webpack_public_path__ + "files/17572cfc1e76759e93a9c3a18d0c9fbc.png";